export default "__VITE_PUBLIC_ASSET__180b1f08__"